import { Text } from '@mantine/core';
import type { ReactNode } from 'react';

type Props = {
  label: string;
  children: ReactNode;
};

/** Paire libellé / valeur d'une liste de description (`<dl>`). */
const SusDetailField = ({ label, children }: Props) => (
  <div>
    <Text component="dt" size="sm" fw={500} c="dimmed">
      {label}
    </Text>
    <Text component="dd" m={0}>
      {children}
    </Text>
  </div>
);

export default SusDetailField;
